module.exports = __webpack_public_path__ + "img/users_dark.88898c17.svg";